// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.If8uoloC628nvlSK9nDK .PLFFtL_ars2CuTrJlYum{margin:20px 0 8px}.If8uoloC628nvlSK9nDK .PLFFtL_ars2CuTrJlYum .LZp24eztwasxwFqnvgdt{align-items:center;padding:4px 8px;display:flex}.If8uoloC628nvlSK9nDK .PLFFtL_ars2CuTrJlYum .LZp24eztwasxwFqnvgdt .Neph_DzyOL0e8e163_rE{color:var(--content-primary-primary);text-overflow:ellipsis;max-width:250px;padding-right:8px;font-size:13px;font-weight:500;line-height:normal;overflow:hidden}.If8uoloC628nvlSK9nDK .PLFFtL_ars2CuTrJlYum .LZp24eztwasxwFqnvgdt .uRe_qp7uKVAWzJhOCX9Z{color:var(--content-primary-tertiary);cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `If8uoloC628nvlSK9nDK`,
	"headerWrapper": `PLFFtL_ars2CuTrJlYum`,
	"header": `LZp24eztwasxwFqnvgdt`,
	"title": `Neph_DzyOL0e8e163_rE`,
	"icon": `uRe_qp7uKVAWzJhOCX9Z`
};
export default ___CSS_LOADER_EXPORT___;
